const register = {
  loginCredentials: "Identifiants de connexion", // translated
  companyInformation: "Informations sur la société", // translated
  contactDetails: "Détails du contact", // translated
  businessName: "Nom de l'entreprise", // translated
  businessAddress: "Adresse d'affaires", // translated
  registrationCode: "Code d'enregistrement", // translated
  businessRegistrationNumber: "Numéro d'immatriculation", // translated
  websiteUrl: "URL de site web", // translated
  mobilePhone: "Téléphone mobile", // translated
  regionStateProvince: "Région/État/Province", // translated
  legalTitle: "Titre légal", // translated
  city: "Ville", // translated
  postalCode: "Code Postal", // translated
  registrationSuccess: "Succès de l'inscription.", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome:
    "Veuillez patienter quelques instants et vous serez redirigé vers la page d'accueil.", // translated
  usernameEmail: "Nom d'utilisateur (e-mail)", // translated
  password: "Mot de passe", // translated
  verifyPassword: "Vérifier le mot de passe", // translated
  documents: "Documents", // translated
  termsAndConditionsSection: "Conditions générales", // translated
  certificateOfIncorporation: "Certificat de constitution", // translated
  acceptTermsAndConditions: "Accepter les conditions générales", // translated
  country: "Pays", // translated
  brandName: "Marque", // translated
  register: "S'inscrire", // translated
  isRequired: "Est requis", // translated
  passwordMin8Chars: "Doit contenir au moins 8 caractères", // translated
  passwordRequiresDigit: "Doit contenir au moins 1 chiffre", // translated
  passwordRequiresLowercase: "Doit contenir au moins 1 lettre minuscule", // translated
  passwordRequiresUppercase: "Doit contenir au moins 1 lettre majuscule", // translated
  passwordRequiresSpecialChar: 'Doit contenir au moins 1 caractère spécial (!@#$%^&*(),.?":{}|<>)', // translated
  uploadFile: "Téléverser un fichier", // translated
  filename: "Nom du fichier :", // translated
  fileType: "Type :", // translated
  fileSize: "Taille :", // translated
  maxFileSize10Mb: "Max. : 10 Mo", // translated
  supportedFileTypes: "Types de fichiers pris en charge :", // translated
  showPassword: "Afficher le mot de passe", // translated
  hidePassword: "Masquer le mot de passe", // translated
  notAvailable: "N/D", // translated
  fileSizeInKb: "{{size}} Ko", // translated
  mobilePhonePlaceholder: "ex. +33123456789", // translated
  websiteUrlPlaceholder: "http://www.exemple.com", // translated
  loading: "Chargement...", // translated
  uploadingDocument: "Téléversement du document...", // translated
  percentUploaded: "{{percent}} % téléversé", // translated
  registrationSuccessful: "Inscription réussie.", // translated
  failedToUploadDocument: "Échec du téléversement du document.", // translated
  fieldIsRequired: "{{field}} {{isRequired}}", // translated
  fieldMinLength: "{{field}} doit comporter plus de {{min}} caractères", // translated
  fieldMustBeValidEmail: "{{field}} doit être un e-mail valide", // translated
  fieldPasswordMinLength: "{{field}} doit contenir au moins 8 caractères", // translated
  fieldPasswordRequiresDigit: "{{field}} doit contenir au moins 1 chiffre", // translated
  fieldPasswordRequiresLowercase: "{{field}} doit contenir au moins 1 lettre minuscule", // translated
  fieldPasswordRequiresUppercase: "{{field}} doit contenir au moins 1 lettre majuscule", // translated
  fieldPasswordRequiresSpecialChar:
    '{{field}} doit contenir au moins 1 caractère spécial (!@#$%^&*(),.?":{}|<>)', // translated
  passwordsDoNotMatch: "{{field}} ne correspond pas à {{otherField}}", // translated
  fieldBetweenLength: "{{field}} doit comporter entre {{min}} et {{max}} caractères", // translated
  postalCodeBetweenLength: "Le code {{field}} doit comporter entre {{min}} et {{max}} caractères", // translated
  invalidUrlFormat: "Format d'URL invalide", // translated
  invalidEmailFormat: "Format d'e-mail invalide", // translated
  emailMustMatchUsername: "l'e-mail doit être identique au nom d'utilisateur (e-mail)", // translated
  mobilePhoneIsRequired: "Le téléphone mobile est obligatoire", // translated
  certificateFileTooLarge: "Le certificat de constitution est trop volumineux", // translated
  termsMustBeAccepted: "Les conditions générales doivent être acceptées", // translated
};


export default register;
